export default {
  AUTHENTICATION_REQUEST: 'AUTHENTICATION_REQUEST',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS'
}
